module.exports = __webpack_public_path__ + "img/2.6319c6a0.svg";